module.exports = __webpack_public_path__ + "img/0499e6_f411cf171ceb46878ab94818397707f9_mv2.6423301b.webp";